export const MENU_OPEN = '@customization/MENU_OPEN';
export const THEME_LOCALE = '@customization/THEME_LOCALE';
export const THEME_RTL = '@customization/THEME_RTL';
export const DRAWER_OPEN = '@drawer/DRAWER_OPEN';
